/**
 * General tab — workspace, country, identity, tags, URL, notes (Voluum lander).
 * For Media Devoted | Created By Ciro Autiero
 */

import { type FC } from 'react';

import { LanderGeneralIdentitySection, LanderMetaFields } from '../sections';
import type { VoluumLanderFormValues } from '../map-voluum-lander-form';

export interface LanderGeneralTabProps {
  values: VoluumLanderFormValues;
  patch: (p: Partial<VoluumLanderFormValues>) => void;
  disabled?: boolean;
}

const LanderGeneralTab: FC<LanderGeneralTabProps> = ({
  values,
  patch,
  disabled,
}) => (
  <div className="space-y-4 pt-3">
    <LanderMetaFields values={values} patch={patch} disabled={disabled} />
    <LanderGeneralIdentitySection
      values={values}
      patch={patch}
      disabled={disabled}
    />
  </div>
);

export default LanderGeneralTab;
